<template>
  <v-snackbar
    v-model="isVisible"
    :color="color"
    :timeout="timeout"
    z-index="10000991"
    location="top"
    class="base-snackbar"
  >
    <div class="base-snackbar__content">
      <v-icon
        v-if="icon"
        :icon="`${icon}`"
      />
      <div class="base-snackbar__content-text d-flex justify-space-between">
        <div class="d-flex align-center row pa-2">
          <div class="d-flex align-center">
            {{ text }}
          </div>
          <div
            v-for="element in texts"
            :key="element.text || element"
            class="d-flex align-center"
          >
            <router-link
              v-if="element.link"
              :to="element.link"
              class="px-2 pointer text-white router-link-color font-weight-bold"
            >
              {{ element.text }}
            </router-link>
            <div v-else>
              {{ element.text || element }}
            </div>
          </div>
        </div>
      </div>
      <v-btn
        v-if="closable"
        icon
        size="small"
        color="white"
        @click="isVisible = false"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </div>
  </v-snackbar>
</template>

<script>
import bus, { eventNames } from '@/lib/eventBus'

export default {
  data() {
    return {
      isVisible: false,
      text: '',
      texts: [],
      icon: '',
      color: '',
      timeout: 5000,
      hideTimeout: null,
      closable: false,
    }
  },
  mounted() {
    bus.$on(eventNames.SHOW_SNACKBAR, (data) => {
      this.showSnackbar(data.color, data.text, data.time, data.texts)
    })
  },
  methods: {
    convertColor(color) {
      const validColors = ['success', 'error', 'warning', 'info']
      if (!validColors.includes(color)) return 'success'

      const vuetifyColorName = `alert-${color}`
      const colors = this.$vuetify?.theme?.global?.current?.colors || {}
      return colors[vuetifyColorName] || 'success'
    },
    convertIcon(icon) {
      const validIcon = ['success', 'error', 'warning', 'info']
      if (validIcon.includes(icon)) return `$${icon}`
      return null
    },
    showSnackbar(newColor, newText, newTime, newTexts = [], closable = true) {
      this.icon = this.convertIcon(newColor)
      this.color = this.convertColor(newColor)
      this.text = newText
      this.texts = newTexts
      this.timeout = newTime || 5000
      this.isVisible = true
      this.hideTimeout = setTimeout(() => (this.timeout = 5000), newTime || 5000)
      this.closable = closable
    },
  },
  unmounted() {
    clearTimeout(this.hideTimeout)
  },
}
</script>
<style scoped>
.v-snackbar {
  z-index: 20000000 !important;
}
a.router-link-color:not(.nav-item):not(.v-alert__content a):not(.v-btn) {
  color: white !important;
}
:deep(.v-snackbar__wrapper) {
  border-radius: 10px;
}
.base-snackbar__content {
  display: flex;
  align-items: center;
  gap: 10px;
  color: white;
}
.base-snackbar__content-text {
  display: flex;
  flex-grow: 1;
  font-weight: 700;
}
</style>
